/*
 * @Description: 配置工具函数
 * @Date: 2025-08-21
 */
import configService from '../services/configService';
import axios from 'axios';

/**
 * 重新加载配置
 * @returns {Promise<Object>} 配置对象
 */
export const reloadConfig = async () => {
  try {
    // 清除缓存的配置
    configService.config = null;
    configService.loadPromise = null;
    
    // 重新加载配置
    const config = await configService.applyAxiosConfig();
    console.log('配置已重新加载:', config);
    return config;
  } catch (error) {
    console.error('重新加载配置失败:', error);
    throw error;
  }
};

/**
 * 获取当前配置
 * @returns {Promise<Object>} 配置对象
 */
export const getCurrentConfig = async () => {
  return await configService.getConfig();
};

/**
 * 获取特定配置项
 * @param {string} key 配置键名
 * @returns {Promise<any>} 配置值
 */
export const getConfigItem = async (key) => {
  return await configService.getConfigItem(key);
};

export default {
  reloadConfig,
  getCurrentConfig,
  getConfigItem
};